import React, { useContext,useEffect } from 'react'
import Navigation from '../../components/Navbar'
import { UserContext } from '../../context/User/user.context'
import "./profile.css"

const Profile = () => {
    const studentLoginDetails=JSON.parse(localStorage.getItem("studentLoginDetails"))
    const studentLoginData=JSON.parse(localStorage.getItem("studentLoginData"))

  return (
    <div className='profilecontainer'>
         <Navigation required={true} studentName={studentLoginDetails.data.student.firstName}/>
         <div className='sprofilecontainer'>
            <div className='studentprofileminicontainer1'>
                 <h4>Student Details</h4>
            </div>      
            <br />
            <div className='studentprofileminicontainer2'>
                 <div className='xyz1'>
                      <label htmlFor='firstname'>FirstName</label>
                      <div className='divinputcontainer' id='firstname'>
                          <p>{studentLoginDetails.data.student.firstName}</p>
                      </div>    
                      <label htmlFor='BirthDate' className='mt-1'>BirthDate</label>
                      <div className='divinputcontainer' id='BirthDate'>
                          <p>{studentLoginDetails.data.student.birthDate}</p>
                      </div>    
                 </div>
                 <div className='xyz2'>
                      <label htmlFor='lastname'>LastName</label>
                      <div className='divinputcontainer' id='lastname'>
                          <p>{studentLoginDetails.data.student.lastName}</p>
                      </div>
                      <label htmlFor='Gender' className='mt-1'>Gender</label>
                      <div className='divinputcontainermini' id='gender'>
                          <p>{studentLoginDetails.data.student.gender}</p>
                      </div>
                 </div>
            </div>
            <div className='studentprofileminicontainer3'>
                      <label htmlFor='address'>Address</label>
                      <div className='divinputcontainer p-2' id='address'>
                          <p>{studentLoginDetails.data.student.address}</p>
                      </div>
            </div>
            <div className='studentprofileminicontainer4'>
                  <div className='xyz1'>
                      <label htmlFor='userName' className='mt-2'>UserName</label>
                      <div className='divinputcontainer' id='userName'>
                          <p>{studentLoginDetails.data.student.userName}</p>
                      </div>    
                      <label htmlFor='postal' className='mt-2'>Postal/Zip Code</label>
                      <div className='divinputcontainer' id='postal'>
                          <p>{studentLoginDetails.data.student.zipcode?studentLoginDetails.data.student.zipcode:"NO Data Found"}</p>
                      </div>    
                      <label htmlFor='email' className='mt-2'>Email</label>
                      <div className='divinputcontainer' id='email'>
                          <p>{studentLoginDetails.data.student.email}</p>
                      </div>    
                      <label htmlFor='education' className='mt-2'>Education</label>
                      <div className='divinputcontainer' id='education'>
                          <p>{studentLoginDetails.data.student.education}</p>
                      </div>    
                  </div>
                  <div className='xyz2'>
                      <label htmlFor='state' className='mt-2'>State</label>
                      <div className='divinputcontainer' id='state'>
                          <p>{studentLoginDetails.data.student.state?studentLoginDetails.data.student.state:"No Data Found"}</p>
                      </div>    
                      <label htmlFor='school' className='mt-2'>School Name</label>
                      <div className='divinputcontainer' id='school'>
                          <p>{studentLoginDetails.data.student.schoolName}</p>
                      </div>    
                      <label htmlFor='mobile' className='mt-2'>Mobile Number</label>
                      <div className='divinputcontainer' id='mobile'>
                          <p>{studentLoginDetails.data.student.mobileNumber}</p>
                      </div>    
                      <label htmlFor='preparingfor' className='mt-2'>Preparing For</label>
                      <div className='divinputcontainer' id='preparingfor'>
                          {studentLoginDetails.data.student.preparingFor.map(item=><p>{item.label}</p>)}
                      </div>    
                  </div>
            </div>
       </div>
    </div>
  )
}

export default Profile